export enum CameraPosition {
  CURRENT = "current",
  REFERENCE = "reference",
}
